// eslint-disable import/no-mutable-exports
let baseUrl, phrUrl, socketUrl, phrUrlV2, baseUrlV2, pwsUrl, phrServiceUrl, opentokApiKey;
if (process.env.API_ENV === 'qa') {
  phrUrl = process.env.PHR_BASE_URL_QA;
  phrUrlV2 = process.env.PHR_BASE_URL_QA_v2;
  baseUrl = process.env.CHR_BASE_URL_QA;
  baseUrlV2 = process.env.CHR_BASE_URL_QA_v2;
  socketUrl = process.env.SOCKET_URL_QA;
  pwsUrl = process.env.PWS_BASE_URL_QA;
  phrServiceUrl = process.env.PHR_SERVICE_URL_QA;
  opentokApiKey = process.env.OPENTOK_QA_APIKEY;
} else if (process.env.API_ENV === 'release') {
  phrUrl = process.env.PHR_BASE_URL_RELEASE;
  phrUrlV2 = process.env.PHR_BASE_URL_RELEASE_v2;
  baseUrl = process.env.CHR_BASE_URL_RELEASE;
  baseUrlV2 = process.env.CHR_BASE_URL_RELEASE_v2;
  socketUrl = process.env.SOCKET_URL_RELEASE;
  pwsUrl = process.env.PWS_BASE_URL_RELEASE;
  phrServiceUrl = process.env.PHR_SERVICE_URL_RELEASE;
  opentokApiKey = process.env.OPENTOK_RELEASE_APIKEY;
} else if (process.env.API_ENV === 'prod') {
  phrUrl = process.env.PHR_BASE_URL_PROD;
  phrUrlV2 = process.env.PHR_BASE_URL_PROD_v2;
  baseUrl = process.env.CHR_BASE_URL_PROD;
  baseUrlV2 = process.env.CHR_BASE_URL_PROD_v2;
  socketUrl = process.env.SOCKET_URL_PROD;
  pwsUrl = process.env.PWS_BASE_URL_PROD;
  phrServiceUrl = process.env.PHR_SERVICE_URL_PROD;
  opentokApiKey = process.env.OPENTOK_PROD_APIKEY;
} else if (process.env.API_ENV === 'local') {
  phrUrl = process.env.PHR_BASE_URL_LOCAL;
  baseUrl = process.env.CHR_BASE_URL_LOCAL;
  baseUrlV2 = process.env.CHR_BASE_URL_LOCAL_v2;
  socketUrl = process.env.SOCKET_URL_LOCAL;
  pwsUrl = process.env.PWS_BASE_URL_LOCAL;
  phrServiceUrl = process.env.PHR_SERVICE_URL_LOCAL;
  phrUrlV2 = process.env.PHR_BASE_URL_LOCAL_v2;
}

export { baseUrl, phrUrl, socketUrl, phrUrlV2, baseUrlV2, pwsUrl, phrServiceUrl, opentokApiKey };
